import getComponent from './component';
import getVisibilityState from './visibility-state';

export default {
  getComponent,
  getVisibilityState,
};
